import API from "../../../services/api";
import JSONbig from "json-bigint";
import axios from "axios";


function parsePostIDsBigInt(postJsonData){
  var jsonWithBigIntPostID = JSONbig.parse(postJsonData);
  jsonWithBigIntPostID.id = jsonWithBigIntPostID.id.toString();
  if (jsonWithBigIntPostID.is_shared_post){
    jsonWithBigIntPostID.shared_from.id = jsonWithBigIntPostID.shared_from.id.toString();
  }
  return jsonWithBigIntPostID

}
export const getPost = async (post_id) => {
  let response = await API.get("public/get_post", {
    transformResponse: [data => data],
    params: {
      post_id,
    },
  });
  return parsePostIDsBigInt(response.data);
};

export const getSpace = async (zip_code) => {
  let response = await API.get("public/get_space_by_zip_code", {
    transformResponse: [data => data],
    params: {
      zip_code,
    },
  });
  var json_with_bigint_space_id = JSONbig.parse(response.data)
  json_with_bigint_space_id.space.id = json_with_bigint_space_id.space.id.toString();
  return json_with_bigint_space_id;
};

export const getSpacePost = async (space_id) => {
  let response = await API.get("public/list_space_posts", {
    transformResponse: [data => data],
    params: {
      space_id,
    },
  });

  return parsePostIDsBigInt(response.data);
};

export const getBanners = async(url) => {
  let response = await axios.get(url, {
    transformResponse: [data => data],
    params: {},
  });
    
  if (response){
    let parsedRes = JSON.parse(response.status)
    let resObj = {};
    resObj["results"] = parsedRes;
    return resObj
  }
};

